import { Button } from "@/components/Core/Button";
import { Input } from "@/components/Core/Input";
import { formRegEx, formRegExReplacer } from "constant/regex";
import { useState } from "react";
import { IoMdCheckmark } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import { toast } from "react-toastify";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./ConfirmPasswordModal.module.css";

export default function ConfirmPasswordModal({
  show,
  setShow,
  onclick,
  loader,
  email,
  code,
}) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSave = () => {
    let params = {
      password,
      passwordConfirm: confirmPassword,
      email,
      code,
    };

    for (let key in params) {
      if (!params[key]) {
        return toast.error(
          `Please fill the ${key
            .replace(formRegEx, formRegExReplacer)
            .toLowerCase()} field!`
        );
      }
    }

    if (password.length < 8) {
      return toast.error("Password must contain more than 8 characters");
    }
    if (password !== confirmPassword) {
      return toast.error("Password and confirm password should be same!");
    }
    onclick(params);
  };
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      header={"Change Password"}
      headerClass={classes.heading}
      showCloseIcon={true}
    >
      <div className={classes.container}>
        <Input
          type={"password"}
          label={"New Password"}
          value={password}
          setter={setPassword}
          placeholder={"Enter New Password"}
        />
        <Input
          type={"password"}
          label={"Confirm New Password"}
          value={confirmPassword}
          setter={setConfirmPassword}
          placeholder={"Confirm New Password"}
        />
        <div className={classes.button}>
          <Button
            label="Cancel"
            variant={"danger"}
            disabled={loader}
            rightIcon={<RxCross2 />}
            onClick={() => setShow(false)}
          />
          <Button
            label={loader ? "Updating..." : "Update"}
            onClick={handleSave}
            disabled={loader}
            rightIcon={<IoMdCheckmark />}
          />
        </div>
      </div>
    </ModalSkeleton>
  );
}
